import * as React from 'react'
import { PackageWholesaleSubscriptionExpandableVariant } from '@modules/package-wholesale/details/subscription/variants/package-wholesale-subscription-expandable-variant'
import { PackageWholesaleSubscriptionExpandableVariantSubtitle } from '@modules/package-wholesale/details/subscription/variants/package-wholesale-subscription-expandable-variant-subtitle'
import { PackageWholesaleCardsSubscriptionSection } from '@modules/package-wholesale/details/subscription/package-wholesale-cards-subscription-section'
import { PackageWholesaleProduct } from '@modules/package-wholesale/models'
import { PackageWholesaleLeafletButton } from '@modules/package-wholesale/details/subscription/package-wholesale-leaflet-button'

interface Props {
  products: PackageWholesaleProduct[]
  leafletUrl: string | null
  isDefaultExpanded?: boolean
}

export const PackageWholesaleSubscriptionVariantSilver = ({
  products,
  leafletUrl,
  isDefaultExpanded,
}: Props): JSX.Element => (
  <PackageWholesaleSubscriptionExpandableVariant
    isDefaultExpanded={isDefaultExpanded}
    variant="silver"
    title={<h5 className="subscription-variant__header is-silver fw-bolder">Pakiet srebrny</h5>}
    icon={<img src={require('@assets/images/subscription-variants/silver.svg')} alt="Pakiet srebrny" height="40" />}
    subtitle={
      <PackageWholesaleSubscriptionExpandableVariantSubtitle
        dates={
          <span>
            od 01.01 do 30.06 oraz <span className="text-nowrap">od 01.09 do 31.12*</span>
          </span>
        }
      />
    }
  >
    <small className="mt-n3 d-block mb-2 font-500 text-darker-gray">* Terminy specjalne z dopłatą</small>
    <PackageWholesaleCardsSubscriptionSection packageWholesaleProducts={products} />
    <PackageWholesaleLeafletButton leafletUrl={leafletUrl} wrapperClassName="mt-3 d-block" />
  </PackageWholesaleSubscriptionExpandableVariant>
)
